import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../stores/auth'
import { authApi } from '../api'

const routes = [
  { path: '/login',            name: 'login',            component: () => import('../views/Login.vue'),            meta: { requiresAuth: false } },
  { path: '/setup',            name: 'setup',            component: () => import('../views/Setup.vue'),            meta: { requiresAuth: false } },
  { path: '/forgot-password',  name: 'forgot-password',  component: () => import('../views/ForgotPassword.vue'),   meta: { requiresAuth: false } },
  { path: '/reset-password',   name: 'reset-password',   component: () => import('../views/ResetPassword.vue'),    meta: { requiresAuth: false } },
  { path: '/onboarding', name: 'onboarding', component: () => import('../views/Onboarding.vue'), meta: { requiresAdmin: true, skipOnboardingCheck: true } },
  { path: '/',            name: 'dashboard', component: () => import('../views/Dashboard.vue') },
  { path: '/sites',       name: 'sites',     component: () => import('../views/Sites.vue') },
  { path: '/sites/new',   name: 'site-new',  component: () => import('../views/SiteNew.vue') },
  { path: '/sites/:name', name: 'site-edit', component: () => import('../views/SiteEdit.vue'), props: true },
  { path: '/sites/:name/analytics', name: 'site-analytics', component: () => import('../views/SiteAnalytics.vue'), props: true },
  { path: '/config',      name: 'config',    component: () => import('../views/ConfigFiles.vue'), meta: { requiresAdmin: true } },
  { path: '/logs',        name: 'logs',      component: () => import('../views/Logs.vue') },
  { path: '/analyzer',    name: 'analyzer',  component: () => import('../views/LogAnalyzer.vue') },
  { path: '/ssl',         name: 'ssl',       component: () => import('../views/Ssl.vue'), meta: { requiresAdmin: true } },
  { path: '/account',     name: 'account',   component: () => import('../views/Account.vue') },
  { path: '/help',        name: 'help',      component: () => import('../views/Help.vue') },
  { path: '/users',         name: 'users',         component: () => import('../views/Users.vue'), meta: { requiresAdmin: true } },
  { path: '/notifications', name: 'notifications', component: () => import('../views/Notifications.vue'), meta: { requiresAdmin: true } },
  { path: '/modsecurity',   name: 'modsecurity',   component: () => import('../views/ModSec.vue'), meta: { requiresAdmin: true } },
  { path: '/audit',         name: 'audit',         component: () => import('../views/AuditLog.vue'), meta: { requiresAdmin: true } },
  { path: '/global',        name: 'global',        component: () => import('../views/GlobalSettings.vue'), meta: { requiresAdmin: true } },
  { path: '/scheduler',     name: 'scheduler',     component: () => import('../views/Scheduler.vue'),      meta: { requiresAdmin: true } },
  { path: '/backup',        name: 'backup',        component: () => import('../views/Backup.vue'),         meta: { requiresAdmin: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuth()

  // Redirect to /setup on first run.
  if (to.name !== 'setup' && to.name !== 'login') {
    try {
      const r = await authApi.setupStatus()
      if (!r.data.setup_complete) return { name: 'setup' }
    } catch { /* ignore */ }
  }

  if (to.meta.requiresAuth === false) return true
  if (!auth.token) return { name: 'login', query: { redirect: to.fullPath } }

  // Admin-only route guard
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'dashboard' }
  }

  // Redirect admin to onboarding if not yet completed
  if (auth.isAdmin && !auth.user?.onboarding_complete && !to.meta.skipOnboardingCheck) {
    return { name: 'onboarding' }
  }

  return true
})

export default router
